import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './DownloadPage.css';

const DownloadPage = () => {
    const navigate = useNavigate();

    const playStoreUrl = "https://play.google.com/store/apps/details?id=com.bunchy.mobile"; 
    const appStoreUrl = "https://apps.apple.com/us/app/bunchy/id6757946184"; 

    const handleDownload = (e, targetUrl) => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        
        // Smart redirection logic as requested
        if (/android/i.test(userAgent)) {
            window.location.href = playStoreUrl;
        } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            window.location.href = appStoreUrl;
        } else {
            // If on desktop, follow the clicked link
            window.location.href = targetUrl;
        }
    };

    return (
        <div className="download-page">
            {/* Main Content */}
            <main className="download-main">
                <div className="download-container">
                    <div className="download-content">
                        <div className="download-text-section">
                            <span className="download-badge">Available Now</span>
                            <h1 className="download-title">
                                Connect with your <span>Community</span> in Private Groups
                            </h1>
                            <p className="download-description">
                                Bunchy is a mobile application designed to connect users through private groups based on shared interests, activities, and experiences in a secure and non-public environment.
                            </p>
                            
                            <div className="download-features">
                                <div className="feature-item">
                                    <span className="feature-icon">🔒</span>
                                    <div>
                                        <h3>Private & Secure</h3>
                                        <p>Your conversations stay within your private groups.</p>
                                    </div>
                                </div>
                                <div className="feature-item">
                                    <span className="feature-icon">📍</span>
                                    <div>
                                        <h3>Local Connections</h3>
                                        <p>Find groups and activities within your city.</p>
                                    </div>
                                </div>
                                <div className="feature-item">
                                    <span className="feature-icon">✨</span>
                                    <div>
                                        <h3>No Public Profiles</h3>
                                        <p>Minimized exposure of personal data by design.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="download-buttons">
                                <button 
                                    className="store-button playstore" 
                                    onClick={(e) => handleDownload(e, playStoreUrl)}
                                >
                                    <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" />
                                </button>
                                <button 
                                    className="store-button appstore" 
                                    onClick={(e) => handleDownload(e, appStoreUrl)}
                                >
                                    <img src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" alt="Download on the App Store" />
                                </button>
                            </div>
                        </div>

                        <div className="download-image-section">
                            <div className="phone-mockup">
                                <img 
                                    src="/app-home-screenshot.png" 
                                    alt="Bunchy App Home" 
                                    className="app-screenshot"
                                    onError={(e) => {
                                        e.target.src = "https://via.placeholder.com/300x600?text=App+Screenshot";
                                        e.target.style.background = "#f0f0f0";
                                    }}
                                />
                                <div className="floating-badge badge-1">5+ Groups</div>
                                <div className="floating-badge badge-2">2 Unread</div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            {/* Footer */}
            <footer className="download-footer">
                <div className="footer-content">
                    <p>© 2026 Bunchy. All rights reserved.</p>
                    <div className="footer-links">
                        <span onClick={() => navigate('/privacy-policy')}>Privacy Policy</span>
                        <span onClick={() => navigate('/terms-conditions')}>Terms & Conditions</span>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default DownloadPage;
